













import Vue from 'vue'

export default Vue.extend({
  name: 'Confirm',
  props: {
    value: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '?',
    },
  },
  data: () => ({}),
  methods: {
    yesClicked() {
      this.$emit('confirmed')
      this.$emit('input', false)
    },
  },
})
